import type { ActionResult } from '@oysterjs/core/graphql/actions';

// A server error's own text is diagnostics, so the page shows its own sentence instead.
const SERVER_ERROR_MESSAGE = 'Something went wrong. Check your connection and try again.';

/** The sentence to show for a refused or failed route action, or null when it worked. */
export const actionFailureMessage = (result: ActionResult<unknown>): string | null => {
  if (result?.applicationError) return result.applicationError.message;
  if (result?.validationErrors?.length) return result.validationErrors[0].message;
  if (result?.serverError) return SERVER_ERROR_MESSAGE;
  return null;
};
